import { render, staticRenderFns } from "./WalletParentHistoryDialog.vue?vue&type=template&id=65732e5c&scoped=true"
import script from "./WalletParentHistoryDialog.vue?vue&type=script&lang=js"
export * from "./WalletParentHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./WalletParentHistoryDialog.vue?vue&type=style&index=0&id=65732e5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65732e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65732e5c')) {
      api.createRecord('65732e5c', component.options)
    } else {
      api.reload('65732e5c', component.options)
    }
    module.hot.accept("./WalletParentHistoryDialog.vue?vue&type=template&id=65732e5c&scoped=true", function () {
      api.rerender('65732e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Wallet/WalletParentHistoryDialog.vue"
export default component.exports